module.exports = __webpack_public_path__ + "media/images/tibor-d4a95ef3fb60e53102e2b37a0412b55c.svg";